// extracted by mini-css-extract-plugin
export default {"watchlistContainer":"Watchlists_watchlistContainer__Ass7S"};